<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-button @click="digAdd" icon="el-icon-plus" style="float: right;margin-right: 10px;">添加</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'version'
        label= '版本'>
      </el-table-column>
      <el-table-column
        prop= 'fileMd5'
        label= '文件Md5'>
      </el-table-column>
      <el-table-column
        prop= 'name'
        label= '名称'>
      </el-table-column>
      <el-table-column
        prop= 'descr'
        label= '描述'>
      </el-table-column>

      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '100'>
        <template slot-scope='scope'>
          <el-button @click='digEdit(scope.row)' type='text' size='small' style="color: #209323">编辑</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="名称" :label-width="formLabelWidth" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="描述" :label-width="formLabelWidth" prop="descr">
          <el-input v-model="form.descr" autocomplete="off"></el-input>
        </el-form-item>        
        <el-form-item label="版本" :label-width="formLabelWidth" prop="version">
          <el-input v-model="form.version" autocomplete="off"></el-input>
        </el-form-item>
        <el-row :style="'padding-left:' + formLabelWidth">
          <el-upload
            class="upload-demo"
            :action="apiUrl + '/file/add/single'"
            :on-success="upLoadSuccess"
            :on-error="upLoadError"
            :file-list="fileList"
            :headers="headers"
            list-type="apk">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-row>
        <el-form-item label="储存路径" :label-width="formLabelWidth" prop="fileMd5">
          <el-input v-model="form.fileMd5" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
export default {
  data () {
    return {
      tableData: [],
      name: '',
      dialogFormVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        version: null,
        fileMd5: null,
        name: null,
        descr: null
      },
      rules: {

      },
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      fileList: [],
      apiUrl: '',
      headers:{}
    }
  },
  created () {
    this.query()
    this.apiUrl = this.$global.apiUrl
    this.headers.token = localStorage.getItem('token');
  },
  methods: {
    upLoadSuccess (res) {
      // console.log(res)
      // {name:'', url:''}
      this.fileList = []
      this.fileList.push({name: res.data.body.name, url: `${this.apiUrl}/file/getOneByByte?md5=${res.data.body.md5}`})
      this.form.fileMd5 = res.data.body.md5
    },
    upLoadError () {
      this.fileList = []
    },
    del (row) {
      let that = this
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/deviceOta/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      document.body.click()
    },
    query () {
      let that = this
      requestService.get(`/deviceOta/listPage?current=${that.current}&pageSize=${that.pageSize}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        // console.log(res)
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    digEdit (row = {}) {
      this.form = {...row}
      this.dialogFormVisible = true
    },
    digAdd () {
      this.form = {}
      this.dialogFormVisible = true
    },
    submitForm (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          that.dialogFormVisible = false
          console.log('add')
          let url = '/deviceOta/add'
          if (that.form.id) {
            url = '/deviceOta/edit'
          }
          requestService.post(url, that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
            that.query()
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/manage-components/deviceOta/Index.vue